<form [formGroup]="printForm">
  <mat-form-field class="form-group">
    <mat-label>Sideoppsett</mat-label>
    <mat-select id="pageLayout" formControlName="pageLayout" ngDefaultControl (selectionChange)="handleNewLayouts()">
      @for (layout of layouts; track layout) {
        <mat-option [value]="layout">
          {{ layout }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field class="form-group">
    <mat-label>Målestokk</mat-label>
    <mat-select id="scale" formControlName="scale" ngDefaultControl (selectionChange)="handleNewScale()">
      @for (scale of scales; track scale) {
        <mat-option [value]="scale">
          {{ scale }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field class="form-group">
    <mat-label>Format</mat-label>
    <mat-select id="format" formControlName="format" ngDefaultControl>
      @for (format of formats; track format) {
        <mat-option [value]="format">
          {{ format }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field class="form-group">
    <mat-label>Tittel</mat-label>
    <input id="title" formControlName="title" ngDefaultControl matInput value="Kart fra Kilden" />
  </mat-form-field>

  <br />
  <span
    ><mat-checkbox
      #printLegend
      (keyup.enter)="printLegend._elementRef.nativeElement.click()"
      formControlName="printLegend">
      Tegnforklaring
    </mat-checkbox>
  </span>
</form>

<footer class="sticky-modal-footer">
  <button class="printButton" mat-button mat-dialog-close>Avbryt</button>
  <button id="submitPrint" class="printButton" (click)="onSubmit()" mat-button cdkFocusInitial>
    @if (showLoader) {
      <span id="loading"></span>
    }
    @if (!showLoader) {
      <span>Skriv ut</span>
    }
  </button>
</footer>
